/*
Poornima 09/19/2022 2701127043 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
Suresh peddavoora 10/26/2022  2701127043 Removed ClassName for Text Fields.
uresh peddavoora 11/01/2022  2701127043 Accordion summary, details Enhancements.
Ashraf 11/18/2022 2701127043 resetting redux data
Prakash 11/23/2022  2701127043  Removed card component.
Ashraf 15/16/2022 2701127043 fixed role access

*/
import React, {useEffect} from 'react';
import RuleGroup from './RuleGroup';
import {useDispatch, useSelector} from 'react-redux';
import {resetData, ResetRuleGroupData as resetRuleGroupData} from '../../../../../redux/reducers/BRE/AddRuleGroup';

function AddRuleGroup({
  setValue,
  setBreCode,
  breCode,
  setTabValue,
  dataReset,
  roleDataBre,
  setRoleDataBre,
  setUsageState,
  rowSelected,
  editExisting,
}) {
  const {ruleGroupData} = useSelector(({addRuleGroup}) => addRuleGroup);
  const [selectedBaseCategory, setSelectedBaseCategory] = React.useState(
    ruleGroupData?.category ? ruleGroupData.category : '',
  );
  const dispatch = useDispatch();
  useEffect(
    () => {
      dispatch(resetData());
      dispatch(resetRuleGroupData());
    },
    [],
  );
  return (
    <>
      <div>
        <RuleGroup
          breCode={breCode}
          dataReset={dataReset}
          setValue={setValue}
          setTabValue={setTabValue}
          selectedBaseCategory={selectedBaseCategory}
          setSelectedBaseCategory={setSelectedBaseCategory}
          roleDataBre={roleDataBre}
          setRoleDataBre={setRoleDataBre}
          rowSelected={rowSelected}
          editExisting={editExisting}
        />

        {/* {ruleGroupData?.code && !dataReset && (
          <div className={classes1.root}>
            <Accordion
              className="accordion-styling"
              elevation={0}
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography className={classes1.heading}>Formula Rule Group Notes</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes1.detailsCard}>
                <SystemNotes setBreCode={setBreCode} breCode={breCode} />
              </AccordionDetails>
            </Accordion>
          </div>
        )} */}
      </div>
    </>
  );
}

export default AddRuleGroup;
